import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../../services/authApi';
import { useSession } from './SessionProvider';
import './AccountControl.css';

/*
 * Top-bar identity. Signed-in users see who they are; everyone else gets a
 * sign-in prompt, because approval actions need a real account even though the
 * shared API key still authorises the rest of the console.
 */

const initialsFor = (principal) => {
  const source = principal?.display_name || principal?.email || '?';
  const parts = source.replace(/@.*$/, '').split(/[\s._-]+/).filter(Boolean);
  return (parts.slice(0, 2).map((p) => p[0]).join('') || '?').toUpperCase();
};

const AccountControl = () => {
  const { principal, loading, signedIn, refresh } = useSession();
  const navigate = useNavigate();
  const location = useLocation();

  if (loading) return null;

  if (!signedIn) {
    return (
      <button
        type="button"
        className="acct-signin"
        onClick={() => navigate(`/login?next=${encodeURIComponent(location.pathname)}`)}
      >
        Sign in
      </button>
    );
  }

  const signOut = async () => {
    await logout();
    await refresh();
    navigate('/login');
  };

  return (
    <div className="acct">
      <span className="acct-avatar" aria-hidden="true">
        {initialsFor(principal)}
      </span>
      <span className="acct-meta">
        <span className="acct-name">{principal.display_name || principal.email}</span>
        <span className="acct-roles">
          {principal.is_admin
            ? 'Administrator'
            : (principal.roles || []).length
              ? `${principal.roles.length} role${principal.roles.length === 1 ? '' : 's'}`
              : 'No roles assigned'}
        </span>
      </span>
      <button type="button" className="acct-signout" onClick={signOut} title="Sign out">
        Sign out
      </button>
    </div>
  );
};

export default AccountControl;
